
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import ManageSide from "./ManageSide";
import Breadcrumb from "../../components/breadcrumb";
import ManageSec from "./ManageSec";
import dataCandi from "../../assets/fakeData/dataCandi";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";

ManageJobs.propTypes = {};

function ManageJobs(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <LoginMobileHeader handleMobile={handleMobile} />
            <LoginHeader clname="act1" handleMobile={handleMobile} />
            {/* <Breadcrumb title="Manage Job" className="breadcrumb-section" /> */}


            <ManageSide />
            <ManageSec data={dataCandi} />
            {/* <Footer /> */}
            <Gotop />
        </>
    );
}

export default ManageJobs;
